export class PortalDevice{
    portalID: number;
    deviceID: number;

    constructor(portalID?: number, deviceID?: number){
        this.portalID = portalID;
        this.deviceID = deviceID;
    }

    getPortalID(): number{
        return this.portalID;
    }
    getDeviceID(): number{
        return this.deviceID;
    }
}


export class Portal {
    portalID: number;
    directorID: number;
    name: string;
    description: string;
    networkID: number;
    portalURL: string;
    primaryColor: string;
    secondaryColor: string;
    greeting: string;
    lastModified: number;
    updatePending: number;
    inactivityTime: number;
    warningTime: number;
    allowImport: number;
    guestID: Number;
    portalDevices: PortalDevice[];
    status: boolean;
    message: string;
    hasGuest: boolean;
    hasUsers: boolean;
    constructor(portalID?: number, directorID?: number, name?: string, description?: string, networkID?: number, portalURL?: string, primaryColor?: string, secondaryColor?: string, greeting?: string, lastModified?: number, updatePending?: number, inactivityTime?: number, warningTime?: number, allowImport?: number, portalDevices?: JSON, status?: boolean, message?: string, hasGuest?: boolean, hasUsers?: boolean, guestID?: Number) {
        this.portalID = portalID;
        this.directorID = directorID;
        this.name = name;
        this.description = description;
        this.networkID = networkID;
        this.portalURL = portalURL;
        this.primaryColor = primaryColor;
        this.secondaryColor = secondaryColor;
        this.greeting = greeting;
        this.lastModified = lastModified;
        this.updatePending = updatePending;
        this.inactivityTime = inactivityTime;
        this.warningTime = warningTime;
        this.allowImport = allowImport;
        this.guestID = guestID;
        this.portalDevices = [];
        for(var i in portalDevices){
            this.portalDevices.push(new PortalDevice(portalDevices[i].portalID, portalDevices[i].deviceID));
        }
        this.status = status;
        this.message = message;
        this.hasGuest = hasGuest;
        this.hasUsers = hasUsers;
    }

    getPortalID():number{
        return this.portalID;
    }

    getDirectorID(): number{
        return this.directorID;
    }

    getNetworkID():number{
        return this.networkID;
    }

    setNetworkID(networkID: number): void{
        this.networkID = networkID;
    }

    getName(): string{
        return this.name;
    }

    setName(name: string): void{
        this.name = name;
    }

    getDescription(): string{
        return this.description;
    }

    setDescription(desc: string): void{
        this.description = desc;
    }

    getURL(): string{
        return this.portalURL;
    }

    setURL(url: string): void{
        this.portalURL = url;
    }

    getPrimaryColor(): string{
        return this.primaryColor;
    }

    setPrimaryColor(c: string): void{
        this.primaryColor = c;
    }

    getSecondaryColor(): string{
        return this.secondaryColor;
    }

    setSecondaryColor(c: string): void{
        this.secondaryColor = c;
    }

    getGreeting(): string{
        return this.greeting;
    }

    setGreeting(g: string): void{
        this.greeting = g;
    }

    getLastModified(): number{
        return this.lastModified;
    }

    setLastModified(lm: number): void{
        this.lastModified = lm;
    }

    getUpdatePending(): number{
        return this.updatePending;
    }

    setUpdatePending(lm: number): void{
        this.updatePending = lm;
    }

    getInactivityTime(): number{
        return this.inactivityTime;
    }

    setInactivityTime(t: number): void{
        this.inactivityTime = t;
    }

    getWarningTime(): number{
        return this.warningTime;
    }

    setWarningTime(t: number): void{
        this.warningTime = t;
    }

    getAllowImport(): number{
        return this.allowImport;
    }

    setAllowImport(t: number): void{
        this.allowImport = t;
    }

    getGuestID(): Number{
        return this.guestID;
    }
    setGuestID(gid: Number): void{
        this.guestID = gid;
    }

    getPortalDevices(): PortalDevice[]{
        return this.portalDevices;
    }

    addPortalDevice(dID: number): void{
        this.portalDevices.push(new PortalDevice(this.portalID, dID));
    }

    removePortalDevice(dID: number): void{
        var i = this.portalDevices.findIndex(pd => pd.getDeviceID() == dID);
        if(i > -1){
            this.portalDevices.splice(i,1);
        }
    }

    clone(): Portal{
        var clone = new Portal();
        clone.portalID = this.portalID;
        clone.directorID = this.directorID;
        clone.name = this.name;
        clone.description = this.description;
        clone.networkID = this.networkID;
        clone.portalURL = this.portalURL;
        clone.primaryColor = this.primaryColor;
        clone.secondaryColor = this.secondaryColor;
        clone.greeting = this.greeting;
        clone.lastModified = this.lastModified;
        clone.updatePending = this.updatePending;
        clone.inactivityTime = this.inactivityTime;
        clone.warningTime = this.warningTime;
        clone.allowImport = this.allowImport;
        clone.guestID = this.guestID;
        clone.portalDevices = [];
        for(var i in this.portalDevices){
            clone.portalDevices.push(new PortalDevice(this.portalDevices[i].portalID, this.portalDevices[i].deviceID));
        }
        clone.status = this.status;
        clone.message = this.message;
        clone.hasGuest = this.hasGuest;
        clone.hasUsers = this.hasUsers;
        return clone;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/portal.ts